import React, {useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBolt} from '@fortawesome/free-solid-svg-icons';
import {faMessage} from '@fortawesome/free-regular-svg-icons/faMessage';
import {useNavigate} from 'react-router-dom';
import {ROUTES} from '../../models/routes.const';
import {faClose} from '@fortawesome/free-solid-svg-icons/faClose';
import {getFromStore, StorePath} from '../../services/store.service';
import {Settings} from '../../models/snippet-payload.model';
import Disclaimer from '../common/Disclaimer';

const Footer = () => {
	const navigate = useNavigate();
	const [showGpt, setShowGpt] = useState(false);
	const settings = getFromStore(StorePath.SETTINGS) as Settings;
	const humanChatText = settings?.gpt_settings?.human_chat_text;
    	const shouldShowChatWithHuman = settings?.gpt_settings?.should_show_chat_with_human;

	const handleHumanRequest = () => {
		navigate(ROUTES.LEAD_FORM);
	};

	const toggleGptMessage = () => {
		setShowGpt(!showGpt);
	};

	return (
		<div className="bg-white flex p-3 items-center rounded-b-md">
			<div className="flex mr-1 cursor-pointer" onClick={toggleGptMessage}>
				<FontAwesomeIcon icon={faBolt} className="mr-1 text-yellow-400"/>
				<div className="text-xs text-gray-500">Powered by ChatGPT</div>
			</div>
	            	{shouldShowChatWithHuman &&
	                	<div className="flex mr-1">
		                    <div className="text-xs text-gray-500 mx-[8px]">|</div>
		                    <div className="flex text-primary items-center cursor-pointer" onClick={handleHumanRequest}>
		                        <FontAwesomeIcon icon={faMessage} className="mr-1 w-3 h-3"/>
		                        <div className="text-xs">{humanChatText}</div>
		                    </div>
		                </div>
	            	}
			{showGpt &&
				<div className="fixed z-20 bg-white text-xs rounded-md shadow border border-primary text-center bottom-[120px] left-[10vw] w-[80vw] p-4 cursor-pointer text-gray-700"
					 onClick={toggleGptMessage}>
					<div className="absolute right-2 top-2 text-gray-700">
						<FontAwesomeIcon icon={faClose}/>
					</div>
					<Disclaimer/>
				</div>
			}
		</div>
	);
};

export default Footer;
